import React, { useEffect, useState } from "react";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/variables.scss";
import "../../../../style/buttons.scss";
import "../../../../style/forms.scss";
import "../../../../style/feature.scss";
import "../../../../style/hovers.scss";
import { AiFillCheckCircle, AiOutlineCheck, AiOutlineUserAdd } from "react-icons/ai";
import { BiLogInCircle } from "react-icons/bi";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { useDispatch, useSelector } from "react-redux";
import { logInWithPassword } from "../../../../app/store/auth/authActions";
import { LoginData } from "../../../models/LoginData";
import useFacility from "../../../../utils/hooks/useFacility";
import { useNavigate } from "react-router";
import { REGISTRATION_PAGE } from "../../../routes";
import { State } from "../../../store";
import { USER_TOKEN } from "../../../store/auth/authMiddleware";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  setStep: (index: number) => void;
}

const initialFormLogin: LoginData = {
  login: "",
  password: "",
  objectIds: "",
  old_token: "",
  rememberMe: false,
};
const BasketSecondStep: React.FC<IProps> = ({ setStep }: IProps) => {
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const userToken = sessionStorage.getItem(USER_TOKEN);
  const parsedUserToken = userToken ? JSON.parse(userToken).sessionToken : "";
  const [form, setForm] = useState<LoginData>({
    ...initialFormLogin,
    objectIds: facilityIds,
    old_token: parsedUserToken,
  });
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { scrollToTop } = useParentMessage();
  const navigate = useNavigate();
  const alertLogin = useSelector((state: State) => state.alerts.errors);
  const isLogged = useSelector((state: State) => state.auth.isLoggedIn);

  useEffect(() => {
    if (isLogged) {
      setStep(4);
    }
    if (!saleConfiguration.allowToMakeAccount) {
      setStep(3);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged]);

  return (
    <>
      {isDesktop ? (
        <div className="basket-second-step flex-between">
          {saleConfiguration.allowToMakeAccount && (
            <>
              <div className="basket-box shadow border">
                <h2>{t("zaloguj_sie")}</h2>

                <div className="forms">
                  <div className="form-icon">
                    <input
                      className="form-label"
                      placeholder={t("adres_email")}
                      value={form.login}
                      onChange={(event) => setForm({ ...form, login: event.target.value })}
                    />
                    <AiFillCheckCircle className="icon-succes" />
                  </div>

                  <div className="form-icon">
                    <input
                      className="form-label"
                      placeholder={t("haslo")}
                      type="password"
                      value={form.password}
                      onChange={(event) => setForm({ ...form, password: event.target.value })}
                    />
                    <AiFillCheckCircle className="icon-succes" />
                  </div>
                  {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}
                  <EAButton
                    title={t("zaloguj_sie")}
                    onClick={() => dispatch(logInWithPassword(form))}
                    endIcon={<BiLogInCircle />}
                    fullWidth
                  />
                </div>
              </div>

              <div className="basket-box shadow border">
                <h2>{t("utworz_konto")}</h2>
                <EAButton
                  title={t("zarejestruj_sie")}
                  onClick={() => navigate(REGISTRATION_PAGE)}
                  endIcon={<AiOutlineUserAdd />}
                  fullWidth
                />
                <ul className="ul">
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("szybsze_kolejne_zakupy")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("pelna_historia_zakupow")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("ustawienia_przypomnien")}</span>
                  </li>
                </ul>
              </div>
            </>
          )}
          <div className="basket-box shadow border">
            <h2>{t("zakupy_bez_logowania")}</h2>
            <EAButton
              onClick={() => {
                setStep(3);
                scrollToTop();
              }}
              title={t("kup_bez_rejestracji")}
              variant="outlined"
              fullWidth
            />
          </div>
        </div>
      ) : (
        <div className="basket-second-step flex-between">
          <div className="basket-box shadow border">
            <b>{t("zakupy_bez_logowania")}</b>
            <EAButton
              onClick={() => {
                setStep(3);
                scrollToTop();
              }}
              title={t("kup_bez_rejestracji")}
              variant="outlined"
              fullWidth
            />
          </div>
          {saleConfiguration.allowToMakeAccount && (
            <>
              <div className="basket-box shadow border">
                <b>{t("zaloguj_sie")}</b>
                <div className="forms">
                  <div className="form-icon">
                    <input
                      className="form-label"
                      placeholder={t("adres_email")}
                      value={form.login}
                      onChange={(event) => setForm({ ...form, login: event.target.value })}
                    />
                    <AiFillCheckCircle className="icon-succes" />
                  </div>

                  <div className="form-icon">
                    <input
                      className="form-label"
                      placeholder={t("haslo")}
                      type="password"
                      value={form.password}
                      onChange={(event) => setForm({ ...form, password: event.target.value })}
                    />
                    <AiFillCheckCircle className="icon-succes" />
                  </div>
                  {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}

                  <EAButton
                    onClick={() => dispatch(logInWithPassword(form))}
                    title={t("zaloguj_sie")}
                    fullWidth
                    endIcon={<BiLogInCircle />}
                  />
                </div>
              </div>
              <div className="basket-box shadow">
                <b>{t("utworz_konto")}</b>
                <EAButton title={t("zarejestruj_sie")} fullWidth endIcon={<AiOutlineUserAdd />} />

                <ul className="ul">
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("szybsze_kolejne_zakupy")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("pelna_historia_zakupow")}</span>
                  </li>
                  <li className="flex-center-center">
                    <AiOutlineCheck className="icon" />
                    <span className="text-li">{t("ustawienia_przypomnien")}</span>
                  </li>
                </ul>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default BasketSecondStep;
